const projectMiddleware = (store) => (next) => (action) => {
    if (action.type.indexOf("_REQUEST") !== -1 && action.project) {
        const appName = store
            .getState()
            .app.environments.find(
                (item) => item.module === action.project
            )?.env;

        if (appName) {
            return next({
                ...action,
                axiosConfig: {
                    ...action.axiosConfig,
                    config: {
                        ...action.axiosConfig?.config,
                        params: {
                            ...action.axiosConfig?.config?.params,
                            _app: appName,
                        },
                    },
                },
            });
        }
    }
    return next(action);
};

export default projectMiddleware;
